var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadEntireRuleSet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C16.3431 10 15 11.3431 15 13V39C15 40.6569 16.3431 42 18 42H22C22.5523 42 23 41.5523 23 41C23 40.4477 22.5523 40 22 40H18C17.4477 40 17 39.5523 17 39V16H37V23C37 23.5523 37.4477 24 38 24C38.5523 24 39 23.5523 39 23V13C39 11.3431 37.6569 10 36 10H18ZM37 14H17V13C17 12.4477 17.4477 12 18 12H36C36.5523 12 37 12.4477 37 13V14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 30.6841L32.4029 21.8246L30.8242 20.5967L25.2871 27.7159L22.9614 25.5126L21.5859 26.9645L25.5122 30.6841Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4144 37.9999L38.0002 32.5857L32.5859 37.9999L34.0002 39.4141L37.0002 36.4141V44.9999H39.0002V36.4141L42.0002 39.4141L43.4144 37.9999Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 39C25 31.8203 30.8203 26 38 26C45.1797 26 51 31.8203 51 39C51 46.1797 45.1797 52 38 52C30.8203 52 25 46.1797 25 39ZM38 28C31.9249 28 27 32.9249 27 39C27 45.0751 31.9249 50 38 50C44.0751 50 49 45.0751 49 39C49 32.9249 44.0751 28 38 28Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadEntireRuleSet);
export default __webpack_public_path__ + "static/media/upload-entire-rule-set.7a8ceec5.svg";
export { ForwardRef as ReactComponent };